// extracted by mini-css-extract-plugin
export default {"edit_btn":"Allmodal_edit_btn__wlBO1","crosebutton":"Allmodal_crosebutton__OBVUk"};